export const removeCamelCase = (key) => {
  if (key === 'sdvCompleted') return 'SDV Completed';
  if (key === 'idNumber') return 'ID Number';
  if (key === 'id') return 'ID';
  if (key === 'idType') return 'ID Type';

  let copyOfKey = key.repeat(1);
  copyOfKey = copyOfKey
    .replace(/([A-Z]+)/g, ' $1')
    .replace(/([A-Z][a-z])/g, ' $1')
    .replace(/^./, (s) => s.toUpperCase());
  return copyOfKey;
};

export const formatDateAsString = (date, monthly) => {
  if (!date) return null;

  const newDate = new Date(date);
  let day = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  if (day < 10) {
    day = '0' + day;
  }

  if (!monthly) {
    if (month < 10) {
      return year + '-0' + month + '-' + day;
    } else {
      return year + '-' + month + '-' + day;
    }
  } else {
    if (month < 10) {
      return '0' + month + '/' + year;
    } else {
      return month + '/' + year;
    }
  }
};

export const timeFromDate = (date) => {
  let time = null;
  if (date) {
    time = date.slice(11, 19);
  }
  return time;
};
